<template>
  <v-flex xs12 pb-3>
    <v-expansion-panel expand>
      <v-expansion-panel-content id="dadosQuestionario" class="background-color: primary">
        <div slot="header">
          <span class="subheading white--text">Dados da Cotação</span>
        </div>
        <v-icon slot="actions" color="white">$vuetify.icons.expand</v-icon>
        <v-stepper v-model="stepAtual" vertical>
          <v-stepper-step step="1" :complete="true">
            Dados Cadastrais
          </v-stepper-step>
          <v-stepper-content step="1">
            <dadoscadastrais ref="dadosCadastrais" :model="questionarioProp"></dadoscadastrais>
          </v-stepper-content>
          <v-stepper-step step="1" :complete="true">
            Dados Operacionais
          </v-stepper-step>
          <v-stepper-content step="1">
            <dadosoperacionais :model="questionarioProp.dadosOperacionais"></dadosoperacionais>
          </v-stepper-content>
          <v-stepper-step step="1" :complete="true">
            Seguros Anteriores
          </v-stepper-step>
          <v-stepper-content step="1">
            <segurosanteriores :model="questionarioProp.segurosAnteriores"></segurosanteriores>
          </v-stepper-content>
          <v-stepper-step step="1" :complete="true">
            Novo Seguro
          </v-stepper-step>
          <v-stepper-content step="1">
            <novoseguro :model="questionarioProp.novoSeguro"></novoseguro>
          </v-stepper-content>
          <v-flex class="text-xs-right" pr-5 pl-5>
            <v-btn 
            color="secondary" 
            class="white--text"
            :loading="loadingPdf"
            :disabled="questionarioProp.status.id == estatusComputed.statusEnum.PROCESSAMENTO || loadingPdf"
            :block="$vuetify.breakpoint.xsOnly" 
            @click="baixarPDF()">
              GERAR PDF
            </v-btn>
          </v-flex>
        </v-stepper>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-flex>

</template>

<script>
import dadoscadastrais from '@/components/pages/solicitacao-consulta/DadosCadastrais'
import dadosoperacionais from '@/components/pages/solicitacao-consulta/DadosOperacionais'
import EStatus from '@/helpers/estatus.js'
import segurosanteriores from '@/components/pages/solicitacao-consulta/SegurosAnteriores'
import novoseguro from '@/components/pages/solicitacao-consulta/NovoSeguro'
import permissoes from '@/helpers/permissoes.js'
import solicitacaoPdf from '@/components/pages/solicitacao-consulta/pdf/solicitacaoPdf'
import usuarioHelper from '@/helpers/usuario-logado'

export default {
  name: 'dadossolicitacao',
  components: {
    dadoscadastrais,
    dadosoperacionais,
    segurosanteriores,
    novoseguro
  },
  props: ['questionarioProp', 'transportadoraProp', 'usuarioAutorProp'],
  data: function() {
    return {
      loadingPdf: false,
      mapaPermissoes: null,
      questionarioModel: null,
      stepAtual: 1
    }
  },
  computed: {
    estatusComputed: function() {
      return EStatus;
    }
  },
  mounted: function() {
    this.mapaPermissoes = permissoes.getMapaPermissoes();
  },
  methods: {
    baixarPDF: function () {
      const self = this;
      self.loadingPdf = true;

      /*solicitacaoPdf.gerarPdfSolicitacao(self.mapaPermissoes, self.questionarioProp, self.transportadoraProp, self.usuarioAutorProp).then(function(pdf) {
        window.open(pdf.blobUrl);
        self.loadingPdf = false;
      });*/
      window.open(`${process.env.URL_QUESTIONARIOMS}/v1/no-auth/baixarPdf?ctrl=${self.questionarioProp.id}&prot=${self.questionarioProp.protocolo}&token=${usuarioHelper.USUARIO_LOGADO().token}`);
      self.loadingPdf = false;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/solicitacao-consulta/DadosSolicitacao.vue